import { render, staticRenderFns } from "./ServiceSearch.vue?vue&type=template&id=0893b708&scoped=true&"
import script from "./ServiceSearch.vue?vue&type=script&lang=js&"
export * from "./ServiceSearch.vue?vue&type=script&lang=js&"
import style0 from "./ServiceSearch.vue?vue&type=style&index=0&id=0893b708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0893b708",
  null
  
)

export default component.exports